import { render, staticRenderFns } from "./WaterMarkContainer.vue?vue&type=template&id=84f7bbd8&"
import script from "./WaterMarkContainer.vue?vue&type=script&lang=ts&"
export * from "./WaterMarkContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports